import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OutletselectionComponent } from '../components/grid/outletselection/outletselection.component';
import { OpenshiftComponent } from '../components/openshift/openshift.component';
import { LoginDataService } from '../services/dhukan/login-data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {


  userBO: any = {};
  userrolerightsColl: any = [];
  userView: any = {};
  outletColl: any = [];


  companyname: any = "";

  organizationname: any = "";

  isadminview: boolean = false;
  isrestaruntview: boolean = false;
  issuperadminview: boolean = false;



  constructor(public router: Router, private loginService: LoginDataService, private productFindService: NgbModal) {
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.userrolerightsColl = this.loginService.userrolerightsColl;
    this.loginService.serviceloginChange.subscribe((value) => {
      this.userView = value
      if (this.userView.userBO) {
        this.userBO = this.userView.userBO

        this.companyname = this.userBO.companyname;

        if (this.userBO.adminview === 'DONE') {
          this.isadminview = true;
        }

        if (this.userBO.restaurantview === 'DONE') {
          this.isrestaruntview = true;
        }

        if (this.userBO.superadminview === 'DONE') {
          this.issuperadminview = true;
        }

        this.outletColl = this.userView.outletColl

        this.fnGetCompanyname();
      }

    });
  }

  ngOnInit() {
    if (localStorage.bstoken === undefined) {
      this.router.navigate(['/Login']);
    }
    else {
      this.loginService.fnGetUserRoleList();
    }


  }

  fnGetCompanyname() {
    if (this.loginService.fnGetCompanyId() > 0) {
      for (let abo of this.outletColl) {
        if (abo.companyid === Number(this.loginService.fnGetCompanyId())) {
          this.organizationname = abo.shortname
        }
      }
    }
    else {
      this.organizationname = "All Outlets"
    }
  }


  fnLogout() {
    localStorage.removeItem("bstoken");
    localStorage.removeItem("bstokenon");
    this.router.navigate(['/Login']);
  }


  fnEditCompanyBtnClick() {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'id': this.loginService.fnGetCompanyId(),
        }
      }

      this.router.navigate(['/AddCompany'], navigationExtras);
    } catch (ex) {
      // this.fnShowErrorMsg(ex);
    }
  }


  fnEditUserBtnClick() {
    try {

      this.router.navigate(['/EditProfile']);
    } catch (ex) {
      // this.fnShowErrorMsg(ex);
    }
  }


  fnMenuMobileClick() {
    this.loginService.isnavmobile = !this.loginService.isnavmobile

    if (this.loginService.isnavmobile) {
      var dv = document.getElementById("divnavbar")
      dv.classList.remove("left-sidebar")
      dv.classList.add("left-sidebarmob")

      var dv = document.getElementById("dvdrop")
      dv.classList.add("backdrop")

    }
    else {
      var dv = document.getElementById("divnavbar")
      dv.classList.remove("left-sidebarmob")
      dv.classList.add("left-sidebar")


      var dv = document.getElementById("dvdrop")
      dv.classList.remove("backdrop")
    }

  }

  fnShowOutletSelection() {

    if (this.loginService.fnCheckOrganizationUser()) {
      const modalRef = this.productFindService.open(OutletselectionComponent, { size: <any>'l' });
      modalRef.componentInstance.selectedcompany = this.organizationname;
      modalRef.componentInstance.companycoll = this.outletColl;

      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        localStorage.setItem('bscmp', receivedEntry.companyid);
        this.fnGetCompanyname()
        window.location.reload();
      });
    }
  }


}
